import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-077c3b99"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "modal__header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Verify"),
  /*#__PURE__*/_createElementVNode("p", { class: "modal__description" }, " Enter your email and new password to maintain your account's security ")
], -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Update account ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold text-center mb-3" }, "Select connection", -1))
const _hoisted_4 = { class: "flex space-x-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "select-box__text" }, "Generate Wallet", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "select-box__text" }, "Metamask", -1))

import { ref, reactive, computed } from 'vue';
import { useUserStore } from '@/store/user';
import PlugConnected from '@/assets/plug-connected.vue';
import ConnectWallet from '@/assets/connect-wallet.vue';
import GenerateWallet from '@/assets/generate-wallet.vue';
import useToastMessage from '@/composables/useToastMessage';
import { useRouter, useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const toast = useToastMessage();
const userStore = useUserStore();
const router = useRouter();
const route = useRoute();

const isShowVerify = ref(false);
const verifyAccount = reactive({
  email: '',
  password: '',
});
const confirmVerifyPassword = ref('');
const isVerifyInvalid = computed(
  () =>
    verifyAccount.password.length === 0 ||
    verifyAccount.password !== confirmVerifyPassword.value
);
const verifyUpdateAccount = async () => {
  try {
    await userStore.verify(verifyAccount);
    isShowVerify.value = false;
  } catch (error) {
    toast.error(error);
  }
};
const verifyModalClosed = () => {
  if (!userStore.email) {
    userStore.logout();
    verifyAccount.email = '';
    verifyAccount.password = '';
    confirmVerifyPassword.value = '';
  }
};

const isShowSelectConnection = ref(false);
const hasSelectConnection = ref(false);

const selectConnection = async (caller: 'createWallet' | 'linkWallet') => {
  hasSelectConnection.value = true;
  try {
    await userStore[caller]();
  } catch (error) {
    toast.error(error);
    hasSelectConnection.value = false;
  }
};

const onSelectConnectionClosed = () => {
  !hasSelectConnection.value && userStore.logout();
};

const modalContentStyle = (width = 'unset') => ({
  width: '100vw',
  'max-width': width,
});

userStore.$subscribe((_, state) => {
  if (!state.me) return;
  const { me, attributes } = state;
  const isAuthenticated = me.authenticated();
  const hasNoEmail = !attributes.email;
  const hasNoAddress = !attributes.ethAddress;
  if (isAuthenticated) {
    if (route.name != 'Donate') {
      isShowVerify.value = hasNoEmail;
    }
    // isShowSelectConnection.value = hasNoAddress;
    if (hasNoAddress) router.push('/landing/verify-account');
  }
});

return (_ctx: any,_cache: any) => {
  const _component_BaseInputText = _resolveComponent("BaseInputText")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_component_BaseModal, {
      modelValue: isShowVerify.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isShowVerify).value = $event)),
      "content-style": modalContentStyle('427px'),
      onClosed: verifyModalClosed
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
          class: "space-y-4"
        }, [
          _createVNode(_component_BaseInputText, {
            modelValue: _unref(verifyAccount).email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(verifyAccount).email) = $event)),
            placeholder: "Email",
            "data-testid": "modal-verify-email"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_BaseInputText, {
            modelValue: _unref(verifyAccount).password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(verifyAccount).password) = $event)),
            type: "password",
            placeholder: "Password",
            "data-testid": "modal-verify-password"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_BaseInputText, {
            modelValue: confirmVerifyPassword.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((confirmVerifyPassword).value = $event)),
            type: "password",
            placeholder: "Confirm Password",
            "data-testid": "modal-verify-confirm-password"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_BaseButton, {
            type: "submit",
            full: "",
            "color-scheme": "primary",
            disabled: _unref(isVerifyInvalid),
            onClick: verifyUpdateAccount,
            "data-testid": "modal-verify-submit"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 32)
      ]),
      _: 1
    }, 8, ["modelValue", "content-style"]),
    _createVNode(_component_BaseModal, {
      modelValue: isShowSelectConnection.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((isShowSelectConnection).value = $event)),
      "content-style": modalContentStyle('388px'),
      onBeforeOpen: _cache[8] || (_cache[8] = ($event: any) => (hasSelectConnection.value = false)),
      onClosed: onSelectConnectionClosed
    }, {
      default: _withCtx(() => [
        _createVNode(PlugConnected, { class: "mb-4" }),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "select-box hoverable",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (selectConnection('createWallet'))),
            "data-testid": "modal-verify-createWallet"
          }, [
            _createVNode(GenerateWallet),
            _hoisted_5
          ]),
          _createElementVNode("div", {
            class: "select-box hoverable",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (selectConnection('linkWallet'))),
            "data-testid": "modal-verify-linkWallet"
          }, [
            _createVNode(ConnectWallet),
            _hoisted_6
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "content-style"])
  ]))
}
}

})